import { render, staticRenderFns } from "./c_hot_menu.vue?vue&type=template&id=c4ef63ae&scoped=true"
import script from "./c_hot_menu.vue?vue&type=script&lang=js"
export * from "./c_hot_menu.vue?vue&type=script&lang=js"
import style0 from "./c_hot_menu.vue?vue&type=style&index=0&id=c4ef63ae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef63ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ef63ae')) {
      api.createRecord('c4ef63ae', component.options)
    } else {
      api.reload('c4ef63ae', component.options)
    }
    module.hot.accept("./c_hot_menu.vue?vue&type=template&id=c4ef63ae&scoped=true", function () {
      api.rerender('c4ef63ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_hot_menu.vue"
export default component.exports